<template>
  <BlSheetChildPage
    style="margin: 0 auto"
    class="max-w-[480px]"
    title="Filter"
    text-action="Reset"
    auto-height
    @close="onClose"
    @clickAction="onResetForm"
  >
    <div>
      <div class="pv-16">
        <div class="ph-16">
          <BlTextAv variation="body-16" weight="bold">Rentang Harga</BlTextAv>
          <div class="flex space-x-3 pt-16">
            <BlFieldMv label="Minimal">
              <div class="bl-textfield has-prepend">
                <div class="bl-textfield__prepend">Rp</div>
                <input
                  id="minimum-price"
                  v-model="form.minimum_price"
                  v-mask="currencyMask"
                  class="bl-textfield__inner"
                  type="tel"
                  placeholder="0"
                />
              </div>
            </BlFieldMv>
            <BlFieldMv label="Maksimal">
              <div class="bl-textfield has-prepend">
                <div class="bl-textfield__prepend">Rp</div>
                <input
                  id="maximum-price"
                  v-model="form.maximum_price"
                  v-mask="currencyMask"
                  class="bl-textfield__inner"
                  type="tel"
                  placeholder="0"
                />
              </div>
            </BlFieldMv>
          </div>
        </div>

        <div class="divider mv-16 w-full border-b border-[#F1F2F5]"></div>

        <div class="ph-16">
          <BlTextAv variation="body-16" weight="bold">Usia Peserta</BlTextAv>
          <div class="flex space-x-3 pt-16">
            <BlFieldMv>
              <div data-testid="age-wrapper" class="bl-textfield has-append" @click="showAgeSheet">
                <input
                  id="age"
                  v-model="form.age"
                  tabindex="0"
                  class="bl-textfield__inner w"
                  type="text"
                  placeholder="18"
                  maxlength="2"
                  disabled
                />
                <div class="bl-textfield__append">Tahun</div>
              </div>
            </BlFieldMv>
          </div>
        </div>

        <div class="divider mv-16 w-full border-b border-[#F1F2F5]"></div>

        <PrakerjaCoursesFilterMultiSelect
          v-model="form.course_types"
          data-testid="multiple-course-types"
          label="Tipe Kelas"
          :data="courseTypeOptions"
        />

        <div class="divider mv-16 w-full border-b border-[#F1F2F5]"></div>

        <PrakerjaCoursesFilterMultiSelect
          v-model="form.education_levels"
          data-testid="multiple-education-levels"
          label="Tingkat Pendidikan"
          :data="educationLevels"
        />

        <div class="divider mv-16 w-full border-b border-[#F1F2F5]"></div>

        <PrakerjaCoursesFilterMultiSelect
          v-model="form.category"
          data-testid="multiple-categories"
          label="Kategori Kelas"
          :data="categoryOptions"
          has-more
          :more-data-list="categories"
        />

        <div v-if="isOnSearchPage" class="divider mv-16 w-full border-b border-[#F1F2F5]"></div>

        <PrakerjaCoursesFilterMultiSelect
          v-if="isOnSearchPage"
          v-model="form.merchants"
          data-testid="multiple-merchants"
          label="Lembaga Pelatihan"
          :data="merchantOptions"
          has-more
          :more-data-list="merchants"
        />

        <div class="divider mv-16 w-full border-b border-[#F1F2F5]"></div>

        <div class="ph-16">
          <BlTextAv variation="body-16" weight="bold">Rating</BlTextAv>
          <div class="pt-16">
            <BlSelectionBlockMv data-testid="rating" :is-active="!!form.rating" text="4.0 ke atas" high-contrast @click="toggleRating">
              <IcoStarMinor slot="iconLeft" style="margin-left: 5px" color="#FAB801" />
            </BlSelectionBlockMv>
          </div>
        </div>
      </div>

      <div id="footer-wrapper" slot="footer" :class="footerClasses">
        <BlButtonAv id="ut-filter-trigger" variation="primary" fullwidth @click="onSubmitFilter">Terapkan</BlButtonAv>
      </div>
    </div>

    <BlSheetMv style="margin: 0 auto" class="max-w-[480px]" :active.sync="isDisplayAgeSheet" data-testid="age-sheet" title="Usia Peserta">
      <div slot="content">
        <BlScrollPickerMv data-testid="age-scroll" :scroll-index="age.selectedIndex" :data="age.list" @change="handleAgeChange" />
        <div class="block p-16 border-t border-[#F1F2F5]">
          <BlButtonAv id="age-submit" variation="primary" fullwidth @click="saveAge">Simpan</BlButtonAv>
        </div>
      </div>
    </BlSheetMv>
  </BlSheetChildPage>
</template>

<script>
import {VueMaskDirective} from 'v-mask';
import {mapGetters} from 'vuex';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import range from 'lodash/range';
import cloneDeep from 'lodash/cloneDeep';
import {BlFieldMv, BlButtonAv, BlSelectionBlockMv, BlTextAv, BlScrollPickerMv} from '@bukalapak/bazaar-mweb-latest';
import {IcoStarMinor} from '@bukalapak/bazaar-visual-next';
import BlSheetChildPage from '../shared/BlSheetChildPage.vue';
import {strRemoveDelimiterToNumber} from 'src/shared/javascripts/string-helpers';
import {COURSE_TYPE} from '../../config/app';
import BlSheetMv from '../temporary-bazaar-components/BlSheetMv/BlSheetMv.vue';
import PrakerjaCoursesFilterMultiSelect from './PrakerjaCoursesFilterMultiSelect.vue';
import prakerjaFilterMixin from '../../mixins/prakerja-filter-mixin';

const currencyMask = createNumberMask({
  prefix: '',
  thousandsSeparatorSymbol: '.',
});

const EDUCATION_LEVELS = ['sd', 'smp', 'sma', 'd1', 'd2', 'd3', 'd4', 's1', 's2', 's3'];

const MIN_OPTIONS = 6;

export default {
  name: 'PrakerjaCoursesFilter',
  directives: {mask: VueMaskDirective},
  components: {
    BlFieldMv,
    BlButtonAv,
    BlSheetMv,
    BlSelectionBlockMv,
    BlTextAv,
    BlSheetChildPage,
    BlScrollPickerMv,
    PrakerjaCoursesFilterMultiSelect,
    IcoStarMinor,
  },
  mixins: [prakerjaFilterMixin],
  data() {
    return {
      currencyMask,
      isDisplayAgeSheet: false,
      age: {
        selectedIndex: 0,
        list: range(18, 64),
      },
      form: {
        minimum_price: null,
        maximum_price: null,
        merchants: [],
        category: [],
        course_types: [],
        education_levels: [],
        age: null,
        rating: null,
      },
      merchantOptions: [],
      categoryOptions: [],
    };
  },
  computed: {
    ...mapGetters('categories', ['getCategoryOptions']),
    ...mapGetters('merchants', ['getMerchants']),
    ...mapGetters('courses', ['getCourses', 'getIsUsingFilter', 'getCoursesFilter', 'getCourseFilterConfig']),
    isOnSearchPage() {
      const parentRouteName = this.$route.matched?.[0]?.name;
      return parentRouteName === 'search';
    },
    courseTypeOptions() {
      const courseTypes = Object.keys(COURSE_TYPE).map((ct) => ({
        value: ct,
        name: COURSE_TYPE[ct],
      }));

      return courseTypes.filter((courseType) => this.getCourseFilterConfig.courseTypes.includes(courseType.value));
    },
    merchantId() {
      const URL = this.$route.params?.id.split('-');
      return Number.parseInt(URL.pop(), 10);
    },
    merchants() {
      return this.getMerchants.map((merchant) => ({name: merchant.name, value: merchant.id}));
    },
    categories() {
      return this.getCategoryOptions.map((category) => ({name: category.name, value: category.id}));
    },
    educationLevels() {
      return EDUCATION_LEVELS.map((level) => ({name: level.toUpperCase(), value: level}));
    },
    isFormFilled() {
      return (
        !!this.form.minimum_price ||
        !!this.form.maximum_price ||
        !!this.form.age ||
        !!this.form.rating ||
        this.form.course_types.length > 0 ||
        this.form.education_levels.length > 0 ||
        this.form.merchants.length > 0 ||
        this.form.category.length > 0
      );
    },
    footerClasses() {
      let baseClass = 'p-16 border-t border-[#F1F2F5]';

      return this.isFormFilled ? 'sticky bottom-0 bg-white ' + baseClass : baseClass;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.prefillForm();

      if (!this.getCourses.length) {
        this.$store.dispatch('courses/fetchCourses');
      }

      // make sure options that config dependent are fetched completely
      await Promise.all([
        this.$store.dispatch('categories/fetchCategories'),
        this.$store.dispatch('merchants/fetchMerchants'),
        this.$store.dispatch('courses/fetchFilterConfig'),
      ]);

      this.setInitialMerchants();
      this.setInitialCategories();
    },
    prefillForm() {
      if (this.getIsUsingFilter) {
        this.form = cloneDeep(this.getCoursesFilter);
      }
    },
    setInitialCategories() {
      this.categoryOptions = this.getInitialOptions(this.form.category, this.categories, this.getCourseFilterConfig.categories);
    },
    setInitialMerchants() {
      this.merchantOptions = this.getInitialOptions(this.form.merchants, this.merchants, this.getCourseFilterConfig.merchants);
    },
    getInitialOptions(values, data, configs) {
      let defaultOptions = values.map((value) => {
        return data.find((option) => option.value === value);
      });

      let additionalOptions = data.filter((item) => !values.includes(item.value));

      if (configs.length > 0) {
        // fill options with unselected config values
        additionalOptions = additionalOptions.filter((item) => configs.includes(item.value));
      } else {
        // fill options with rest of API data
        additionalOptions = additionalOptions.splice(0, MIN_OPTIONS - values.length);
      }

      return [...defaultOptions, ...additionalOptions];
    },
    showAgeSheet() {
      // reset age scroll value to match with filter
      let indexAge = 0;

      if (!!this.form.age) {
        indexAge = this.age.list.findIndex((val) => val === this.form.age);
      }

      this.age.selectedIndex = indexAge;
      this.isDisplayAgeSheet = true;
    },
    handleAgeChange(_val, index) {
      this.age.selectedIndex = index;
    },
    saveAge() {
      this.form.age = this.age.list[this.age.selectedIndex];
      this.isDisplayAgeSheet = false;
    },
    courseTypeSelected(val) {
      return this.form.course_types.includes(val);
    },
    selectCourseType(val) {
      let index = this.form.course_types.indexOf(val);

      if (index < 0) {
        this.form.course_types.push(val);
      } else {
        this.form.course_types.splice(index, 1);
      }
    },
    toggleRating() {
      this.form.rating = !this.form.rating ? 4 : null;
    },
    onResetForm() {
      this.form.minimum_price = null;
      this.form.maximum_price = null;
      this.form.category = [];
      this.form.age = null;
      this.form.education_levels = [];
      this.form.rating = null;
      this.form.course_types = [];
      if (this.isOnSearchPage) {
        this.form.merchants = [];
      }
    },
    onSubmitFilter() {
      const minimum_price = strRemoveDelimiterToNumber(this.form.minimum_price);
      const maximum_price = strRemoveDelimiterToNumber(this.form.maximum_price);

      const payload = {
        minimum_price,
        maximum_price,
        category: this.form.category,
        merchants: this.form.merchants,
        keywords: this.getCoursesFilter?.keywords,
        education_levels: this.form.education_levels,
        age: this.form.age,
        rating: this.form.rating,
        course_types: this.form.course_types,
      };

      if (!this.isOnSearchPage) payload.merchants = [this.merchantId];

      this.$store.commit('categories/setSelectedCategories', this.form.category);
      this.$store.commit('courses/setCoursesFilter', payload);
      this.$store.commit('courses/resetCourses');
      this.$store.dispatch('courses/fetchCourses');
      this.onClose();
    },
  },
};
</script>
